// Stub database service — replace with real implementation
export const getCategories = async () => {
  return [];
};
